import { reduirePhoto, sha256Hex } from '../terrain/photos';
import { requete } from '../api/client';
import { ErreurApi } from '../api/erreurs';
export interface PhotoLocale {
  id: string;
  mission_id: string;
  mission: string;
  base64: string;
  empreinte: string;
  taille: number;
  etat: 'attente' | 'envoyee' | 'erreur' | 'ecartee';
  erreur: string | null;
  piece_id?: string;
}
export async function preparerPhoto(
  source: Blob,
  mission_id: string,
  mission: string,
): Promise<PhotoLocale> {
  const reduite = await reduirePhoto(source);
  if (reduite.taille > 1024 * 1024)
    throw new Error('La photo réduite dépasse 1 Mio ; choisissez une image plus petite');
  const octets = new Uint8Array(await reduite.fichier.arrayBuffer());
  let texte = '';
  for (let i = 0; i < octets.length; i += 8192)
    texte += String.fromCharCode(...octets.subarray(i, i + 8192));
  return {
    id: crypto.randomUUID(),
    mission_id,
    mission,
    base64: btoa(texte),
    empreinte: reduite.empreinte,
    taille: reduite.taille,
    etat: 'attente',
    erreur: null,
  };
}
export async function transmettrePhoto(
  p: PhotoLocale,
  verifier: () => void,
  transport = requete,
): Promise<string> {
  const octets = Uint8Array.from(atob(p.base64), (c) => c.charCodeAt(0));
  if (
    octets.length !== p.taille ||
    octets.length > 1024 * 1024 ||
    (await sha256Hex(octets)) !== p.empreinte
  )
    throw new Error('Photo locale altérée ; la copie est conservée');
  const chemin = `/pieces-jointes/objets/intervention/${p.mission_id}`;
  const retrouver = async () => {
    verifier();
    const liste = await transport<{ elements: { id: string; empreinte: string }[] }>(chemin);
    verifier();
    return liste.elements.find((x) => x.empreinte === p.empreinte)?.id;
  };
  const deja = await retrouver();
  if (deja) return deja;
  const formulaire = new FormData();
  formulaire.append('fichier', new Blob([octets], { type: 'image/jpeg' }), `terrain-${p.id}.jpg`);
  verifier();
  try {
    const piece = await transport<{ id: string }>(chemin, { methode: 'POST', corps: formulaire });
    verifier();
    return piece.id;
  } catch (e) {
    if (e instanceof ErreurApi && e.statut === 409) {
      const id = await retrouver();
      if (id) return id;
    }
    throw e;
  }
}
